<h2 mat-dialog-title>Módulos da Solução</h2>

<mat-dialog-content>
  <p><strong>Solução:</strong> {{ data.solutionName || 'Não definida' }}</p>

  <div *ngIf="data.modules?.length; else noModules">
    <div class="modules-grid">
      <mat-card
        *ngFor="let module of data.modules"
        class="module-card"
        [class.selected]="isSelected(module.id)"
        (click)="toggle(module.id)">
        <div class="module-content">
          <div class="module-header">
            <mat-icon class="module-icon">view_module</mat-icon>
            <div class="module-name-wrapper">{{ data.planName || 'Plano' }}</div>
            <mat-icon *ngIf="isSelected(module.id)" class="check-icon" color="primary">
              check_circle
            </mat-icon>
          </div>
          <div class="info-row">
            <span class="info-label">Código:</span>
            <span class="info-value">{{ data.variationCode || '--' }}</span>
          </div>
          <div class="info-row">
            <span class="info-label">Tipo Produto/Solução:</span>
            <span class="info-value">{{ data.productTypeLabel || '--' }}</span>
          </div>
          <div class="info-row">
            <span class="info-label">Produto/Solução:</span>
            <span class="info-value">{{ data.solutionName || '--' }}</span>
          </div>
          <div class="info-row">
            <span class="info-label">Módulo:</span>
            <span class="info-value">{{ module.name || '--' }}</span>
          </div>
          <div class="info-row">
            <span class="info-label">Valor de Acesso:</span>
            <span class="info-value">{{ (module.accessValue || 0) | currency:'BRL' }}</span>
          </div>
          <div class="info-row">
            <span class="info-label">Custo:</span>
            <span class="info-value">{{ (module.cost || 0) | currency:'BRL' }}</span>
          </div>
          <div class="info-row">
            <span class="info-label">Status:</span>
            <span class="info-value">{{ data.statusLabel || 'ATIVO' }}</span>
          </div>
        </div>
      </mat-card>
    </div>
  </div>

  <ng-template #noModules>
    <p>Nenhum módulo encontrado para esta solução.</p>
  </ng-template>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-raised-button color="primary" (click)="save()">Selecionar</button>
  <button mat-stroked-button color="primary" (click)="close()">Fechar</button>
</mat-dialog-actions>
